var map = {
	"./afb-color.svg": 1599,
	"./afb.svg": 1600,
	"./alb-color.svg": 1601,
	"./alb.svg": 1602,
	"./amb-color.svg": 1603,
	"./amb.svg": 1604,
	"./bbbaidja-color.svg": 1605,
	"./bbbaidjaxxx-color.svg": 1606,
	"./bdinidjaxxx-color.svg": 1607,
	"./bimb-color.svg": 1608,
	"./bimb.svg": 1609,
	"./bkr-color.svg": 1610,
	"./bkr.svg": 1611,
	"./bmriidja-color.svg": 1612,
	"./bniaidja-color.svg": 1613,
	"./bninidja-color.svg": 1614,
	"./bninidjaxxx-color.svg": 1615,
	"./bpay-color.svg": 1616,
	"./brinidja002-color.svg": 1617,
	"./bsmdidjaxxx-color.svg": 1618,
	"./bsn-color.svg": 1619,
	"./bsn.svg": 1620,
	"./btanidjaxxx-color.svg": 1621,
	"./cenaidja-color.svg": 1622,
	"./cenaidjaxxx-color.svg": 1623,
	"./cimb-color.svg": 1624,
	"./cimb.svg": 1625,
	"./citi-color.svg": 1626,
	"./citi.svg": 1627,
	"./default-bank-icon-color.png": 1628,
	"./default-bank-icon.png": 1629,
	"./gxbank-color.svg": 1630,
	"./hlb-color.svg": 1631,
	"./hlb.svg": 1632,
	"./hsbc-color.svg": 1633,
	"./hsbc.svg": 1634,
	"./ibbkidjaxxx-color.svg": 1635,
	"./kwh-color.svg": 1636,
	"./kwh.svg": 1637,
	"./mbb-color.svg": 1638,
	"./mbb.svg": 1639,
	"./nispidjaxxx-color.svg": 1640,
	"./ocbc-color.svg": 1641,
	"./ocbc.svg": 1642,
	"./pbb-color.svg": 1643,
	"./pbb.svg": 1644,
	"./pinbidja-color.svg": 1645,
	"./rhb-b.svg": 1646,
	"./rhb-color-b.svg": 1647,
	"./rhb-color.svg": 1648,
	"./rhb.svg": 1649,
	"./scb-color.svg": 1650,
	"./scb.svg": 1651,
	"./tng-color.svg": 1652,
	"./uob-color.svg": 1653,
	"./uob.svg": 1654
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 127;